import { WithCompanyId } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    InputField,
    maxInputTextLength,
    optionalEmail,
    optionalUrl,
    presence,
    TextareaField,
    TelephoneInputField,
} from '@mews-commander/legacy-form';
import { ResponsiveTwoColumnsFormFields } from '@mews-commander/ui';
import SearchMotherCompanyNameField from './SearchMotherCompanyNameField';

export const companyContactInfoFieldsConstraints = {
    name: { presence, length: maxInputTextLength },
    department: { length: maxInputTextLength },
    email: { optionalEmail },
    websiteUrl: { optionalUrl },
    referenceId: { length: maxInputTextLength },
    externalIdentifier: { length: maxInputTextLength },
};

const companyNameProps = {
    name: 'name',
    label: <LocalizedText textKey={TextKey.CompanyName} />,
    required: true,
};

const departmentProps = {
    name: 'department',
    label: <LocalizedText textKey={TextKey.Department} />,
};

const emailProps = {
    name: 'email',
    label: <LocalizedText textKey={TextKey.InvoicingEmail} />,
};

const websiteUrlProps = {
    name: 'websiteUrl',
    label: <LocalizedText textKey={TextKey.Website} />,
};

const referenceIdProps = {
    name: 'referenceId',
    label: <LocalizedText textKey={TextKey.ReferenceId} />,
};

const externalIdentifierProps = {
    name: 'externalIdentifier',
    label: <LocalizedText textKey={TextKey.ExternalIdentifier} />,
};

const notesProps = {
    name: 'notes',
    label: <LocalizedText textKey={TextKey.Notes} />,
};

interface CompanyContactInfoFieldsProps extends WithCompanyId {
    form: string;
}

export const CompanyContactInfoFields = ({ form, companyId }: CompanyContactInfoFieldsProps) => (
    <>
        <InputField {...companyNameProps} />
        <ResponsiveTwoColumnsFormFields>
            <SearchMotherCompanyNameField form={form} companyId={companyId} />
            <InputField {...departmentProps} />
            <InputField {...emailProps} />
            <InputField {...websiteUrlProps} />
            <InputField {...referenceIdProps} />
            <TelephoneInputField />
            <InputField {...externalIdentifierProps} />
        </ResponsiveTwoColumnsFormFields>
        <TextareaField {...notesProps} />
    </>
);
